import { twMerge } from 'tailwind-merge';
import { isEmpty } from '@witmetrics/utils/misc';
import { useFormVersionFields } from '@witmetrics/data-store';
import { useFormProvider } from '@/providers/FormProvider';
import Card from '@/components/Card';
import FieldBlock from './FieldBlock';
import { classes } from './utils';

export default function FormBuilder() {
  const { versionId, answers, activeFieldId } = useFormProvider();
  const fields = useFormVersionFields(versionId);

  if (isEmpty(fields)) {
    return (
      <Card className={twMerge(classes.card, classes.emptyCard)}>
        <div className={classes.emptyMessage}>Empty form.</div>
      </Card>
    );
  }

  return (
    <Card className={classes.card}>
      <ul className={classes.list}>
        {fields.map((f) => (
          <FieldBlock
            key={f.id}
            active={f.id === activeFieldId}
            fieldId={f.id}
          />
        ))}
      </ul>
    </Card>
  );
}
